import api from './api';

/**
 * Obtiene el estado actual del lobby para un juego específico.
 * @param {string} gameId - El ID del juego.
 * @returns {Promise<object>} El objeto del estado del lobby.
 */
export const getLobbyState = async (gameId) => {
  const response = await api.get(`/api/games/${gameId}/lobby`);
  return response.data.lobby; // Devolvemos directamente el objeto del lobby
};

/**
 * Establece el estado de "listo" de un jugador en el lobby.
 * @param {string} gameId - El ID del juego.
 * @param {boolean} isReady - El nuevo estado de listo.
 * @returns {Promise<object>} La respuesta completa de la API.
 */
export const setReadyStatus = async (gameId, isReady) => {
  const response = await api.post(`/api/games/${gameId}/ready`, { is_ready: isReady });
  return response;
};

/**
 * Inicia el juego desde el lobby.
 * @param {string} gameId - El ID del juego.
 * @returns {Promise<object>} La respuesta completa de la API.
 */

export const startGame = async (gameId) => {
  const response = await api.post(`/api/games/${gameId}/start`);
  return response;
};